// DateFilter.tsx
import React from 'react';
import { Grid, Button, Icon } from '@material-ui/core';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { ptBR } from 'date-fns/locale';

type DateFilterProps = {
    filterDate: Date | null;
    setFilterDate: (date: Date | null) => void;
    titulo: string;
};

const DateFilter: React.FC<DateFilterProps> = ({ filterDate, setFilterDate, titulo }) => {
    return (
        <Grid
            container
            style={{
                marginTop: '0.5rem',
                marginBottom: '0.5rem',
                border: '1px solid #ccc',
                padding: '8px',
                borderRadius: '4px',
                maxWidth: '240px'
            }}
        >
            <Grid item >
                <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                    <DatePicker
                        id="news-date"
                        variant="inline"
                        value={filterDate}
                        inputVariant="standard"
                        label={titulo}
                        minDate={new Date(0)}
                        onChange={(date) => setFilterDate(date ?? null)}
                        InputProps={{
                            readOnly: true,
                        }}
                        format="dd/MM/yyyy"
                    />
                </MuiPickersUtilsProvider>
            </Grid>
            <Grid
                item
                xs={1}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
                <Button
                    onClick={() => setFilterDate(null)}
                    variant="text"
                    fullWidth
                    style={{ height: '100%' }}
                    onMouseOver={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                    onMouseOut={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                >
                    <Icon>delete_outline</Icon>
                </Button>
            </Grid>
        </Grid>
    );
};

export default DateFilter;
